import React, { PropsWithChildren } from 'react';
import { PageTitleContainerStyles } from "./page-title-container-styles";

export const PageTitleContainer = ({children}: PropsWithChildren<{}>) => {
    const classes = PageTitleContainerStyles();
    
    return (
        <div className={classes.titleContainer}>
            {children}
        </div>
    );
}
